import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, HashRouter,Routes, Route, Navigate } from 'react-router-dom'
import Rootview from "@/pages/rootview";
import Error from "@/pages/error";
import AutnToken from "@/components/autnToken"
import Login from "@/pages/login";

function App() {
  return (
    <HashRouter>
      {/*只匹配一个，匹配成功就不往下匹配，效率高*/}
      <Routes>
        {/* 重定向到home */}
        <Route path="/" element={<Navigate to="/home" />} />
        {/*   react-router-dom v6写法 ：父/根路径需要指定 * 通配符   */}
        <Route path="/*" element={<Rootview />}></Route>
        {/* 登录页 */}
        <Route path="/login" element={<Login />}></Route>
        {/*配置404页面*/}
        <Route path="/404" element={<Error />}></Route>
      </Routes>
    </HashRouter>
  );
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



